import axios from "axios";

// Keep API calls on the current HTTPS origin in production. This prevents
// browsers from blocking searches as mixed content when an old HTTP backend
// address remains in the build environment.
const CONFIGURED_BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
const BACKEND_URL =
  typeof window !== "undefined" &&
  window.location.protocol === "https:" &&
  CONFIGURED_BACKEND_URL.startsWith("http:")
    ? window.location.origin
    : CONFIGURED_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: false,
});

// Token in localStorage as a fallback for ingress paths where cookies may not survive
let _token = typeof window !== "undefined" ? localStorage.getItem("rm_token") : null;

export function setToken(t) {
  _token = t || null;
  if (t) localStorage.setItem("rm_token", t);
  else localStorage.removeItem("rm_token");
}

api.interceptors.request.use((config) => {
  if (_token) config.headers.Authorization = `Bearer ${_token}`;
  return config;
});

export default api;
